import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import {
  getFormsySubmissionsV2,
  saveFormsyRelatedObject,
  saveFormsySubmission,
  sendEmail,
} from "../services/soar";

export async function loadFormsySubmissionV2(id, setData) {
  const toastId = toast.loading("Loading");
  getFormsySubmissionsV2(id).then((response) => {
    toast.update(toastId, {
      render: "Form Loaded",
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      autoClose: 1000,
      closeOnClick: true,
    });
    setData(response.data[0]);
  });
}

export async function dataChange(
  input,
  data,
  setData,
  touched,
  setTouched,
  timeoutId,
  setTimeoutId,
  table,
  index,
  field
) {
  const obj = { ...data };
  if (table && field && index !== undefined) {
    obj.Results[table][index][field] = input.value;
  } else {
    obj.Results[input.name] =
      input.type === "checkbox" ? input.checked : input.value;
  }

  setData(obj);
  const touchedObj = { ...touched, [input.name]: true };
  setTouched(touchedObj);

  let newTimeoutId;
  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  const touchedFields = Object.keys(touchedObj).filter(
    (field) => touchedObj[field]
  );

  if (touchedFields.length >= 5) {
    clearTimeout(timeoutId);
    saveFormsyV2(data, "Update");
    touchedFields.forEach((field) => (touchedObj[field] = false));
  } else
    newTimeoutId = setTimeout(() => {
      touchedFields.forEach((field) => (touchedObj[field] = false));
      saveFormsyV2(data, "Update");
    }, 20000);

  setTimeoutId(newTimeoutId);
}

export async function saveFormsyV2(data, command) {
  const toastId = toast.info("Saving");
  const obj = { ...data };
  obj.Compliancy = {
    date: data.Results?.DateSupervision,
  };
  obj.Results = JSON.stringify(data.Results);
  saveFormsySubmission(obj, command).then((response) => {
    if (response.data[0].code === "success") {
      toast.update(toastId, {
        render: "Form Saved",
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 2000,
        closeOnClick: true,
      });
    } else {
      toast.update(toastId, {
        render: `Error Saving Form: ${response.data[0].message}`,
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: false,
        closeOnClick: true,
      });
    }
  });
}

export async function ShareWith(submissionIds, sharedWith) {
  submissionIds.forEach(async (l) => {
    //const shared = [];

    //get subission data for l
    const formData = await getFormsySubmissionsV2(l);

    await sharedWith.forEach(async (s, index) => {
      //filter out shared records for s and see if already shared with user
      if (
        formData.data[0].Related === undefined ||
        formData.data[0].Related === null ||
        formData.data[0].Related?.filter(
          (f) =>
            f.ObjectType === "Shared" &&
            f.ObjectJSON.azureId.toUpperCase() === s.azureId.toUpperCase() &&
            f.Active === true
        ).length === 0
      ) {
        const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;

        const obj = {
          Action: "Insert",
          ObjectType: "Shared",
          ObjectJSON: {
            name: s.name,
            azureId: s.azureId,
            domain: s.domain,
            sharedById: safyUser.azureId.toUpperCase(),
            sharedByName: safyUser.displayName,
            sharedByDomain: safyUser.email,
            date: new Date().toLocaleDateString(),
          },
        };
        //shared.push(obj);
        //if (index === sharedWith.length - 1) {
        await saveFormsyRelatedObject(l, [obj]);

        if (formData.data[0].FinalSigned === true) {
          const link = `${
            process.env.REACT_APP_ENVIRONMENT === "Production"
              ? "https://safyportal.safy.org/share"
              : "https://safyportaltest.safy.org/share"
          }/supervision/${
            formData.data[0].ContainerId ===
            "A51B13BE-6B02-EF11-8076-DC98408D5418"
              ? "individual"
              : "group"
          }/${l.toString()}`;
          sendEmail(
            `${s.domain}`,
            s.sharedByDomain,
            "A Supervision Log has been shared with you",
            `${s.sharedByName} has shared a supervision log with you at  <a href="${link}">${link}</a>`
          ).then((response) => {
            console.log("Email Response", response);
            if (JSON.parse(response).SystemResponse[0].Code === "Success") {
              toast.success(`Email Sent To ${s.domain}`);
            } else {
              toast.error(
                `Error in sending email: ${
                  JSON.parse(response).SystemResponse[0].Message
                }`
              );
            }
          });
        }
        // } else {
        // }
        console.log("Skipping, Already Shared With User");
      }
    });
  });
}

export async function deactivateShared(submissionId) {
  await getFormsySubmissionsV2(submissionId).then((response) => {
    const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;

    const submission = response.data[0];
    const shared = submission.Related.filter(
      (r) =>
        r.ObjectType === "Shared" &&
        r.ObjectJSON.azureId.toUpperCase() === safyUser.azureId.toUpperCase() &&
        r.Active === true
    );

    let deactiveRecords = [];
    shared.forEach((i) => {
      const obj = {
        Action: "Deactivate",
        RelatedId: i.RelatedId,
      };
      deactiveRecords.push(obj);
    });

    saveFormsyRelatedObject(submissionId, deactiveRecords);
    toast.success("Removed");
  });
}

export async function deactivateForm(submissionId, callback) {
  // add confirmation dialog
  const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;
  confirmAlert({
    title: "Delete Log",
    message: "Are you sure you want to delete this Supervision Log?",
    buttons: [
      {
        label: "Yes",
        //failing here
        onClick: () => {
          const log = {
            SubmissionId: submissionId,
            ModifiedById: safyUser.azureId,
            ModifiedByName: safyUser.displayName,
          };

          saveFormsySubmission(log, "Deactivate").then((response) => {
            if (response.data[0].code === "success") {
              toast.success("Deactivated");
              callback();
            } else {
              toast.error(`Error: ${response.data[0].message.toString()}`);
            }
          });
        },
      },
      {
        label: "No",
        onClick: () => {
          /* do nothing */
        },
      },
    ],
  });
}

export async function signForm(submissionId, signature) {
  return saveFormsyRelatedObject(submissionId, [signature]);
}

export async function finalSignForm(submissionId) {
  const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;
  const log = {
    SubmissionId: submissionId,
    ModifiedById: safyUser.azureId,
    ModifiedByName: safyUser.displayName,
  };

  await saveFormsySubmission(log, "FinalSign").then((response) => {
    if (response.data[0].code === "success") {
      console.log("Final Signed");
    } else {
      toast.error(`Error: ${response.data[0].message.toString()}`);
    }
  });
}

export async function lockForm(submissionId) {
  const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;
  const log = {
    SubmissionId: submissionId,
    ModifiedById: safyUser.azureId,
    ModifiedByName: safyUser.displayName,
  };

  await saveFormsySubmission(log, "FormLock").then((response) => {
    if (response.data[0].code === "success") {
      console.log("Form Locked");
    } else {
      toast.error(`Error: ${response.data[0].message.toString()}`);
    }
  });
}

export async function shareLockedForm(data, signersRole) {
  const link = `${
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "https://safyportal.safy.org/share"
      : "https://safyportaltest.safy.org/share"
  }/supervision/${
    data.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
      ? "individual"
      : "group"
  }/${data.SubmissionId.toString()}`;
  const initiatingUser =
    signersRole === "Supervisee"
      ? `${data.PrimaryObjectUser}@safy.org`
      : `${data.SecondaryObjectUser}@safy.org`;
  const initiatingName =
    signersRole === "Supervisee"
      ? `${data.PrimaryObjectName}@safy.org`
      : `${data.SecondaryObjectName}@safy.org`;
  const sharedUser =
    signersRole === "Supervisee"
      ? `${data.SecondaryObjectUser}@safy.org`
      : `${data.PrimaryObjectUser}@safy.org`;
  sendEmail(
    sharedUser,
    initiatingUser,
    "Supervision Log",
    `${initiatingName} has completed a supervision log for you at <a href="${link}">${link}</a>`
  ).then((response) => {
    console.log("Email Response", response);
    if (JSON.parse(response).SystemResponse[0].Code === "Success") {
      toast.success(`Email Sent To ${sharedUser}`);
    } else {
      toast.error(
        `Error in sending email: ${
          JSON.parse(response).SystemResponse[0].Message
        }`
      );
    }
  });

  const shared = data?.Related?.filter(
    (r) => r.ObjectType === "Shared" && r.Active === true
  );

  if (shared?.length > 0) {
    shared.forEach((s) => {
      const sharedUser = s.ObjectJSON.domain;
      const sharedBy = s.ObjectJSON.sharedByName;
      const sharedByEmail = s.ObjectJSON.sharedByDomain;
      sendEmail(
        sharedUser,
        "safyautoemail@Safy365.onmicrosoft.com",
        "A Supervision Log has been shared with you",
        `${sharedBy} has shared a supervision log with you at <a href="${link}">${link}</a>`
      ).then((response) => {
        console.log("Email Response", response);
        if (JSON.parse(response).SystemResponse[0].Code === "Success") {
          toast.success(`Email Sent To ${sharedUser}`);
        } else {
          toast.error(
            `Error in sending email: ${
              JSON.parse(response).SystemResponse[0].Message
            }`
          );
        }
      });
    });
  }
}
